import { Network, isSolanaNetwork } from 'types/networks';

const EVM_EXPLORER_MAP: Record<string, string> = {
  '137': 'https://polygonscan.com',
  '56': 'https://bscscan.com',
  '43114': 'https://snowtrace.io',
  '1': 'https://etherscan.io',
};

export const getExplorerAddressUrl = (
  network: Network | null | undefined,
  address: string
): string => {
  if (!network || !address) return '#';

  if (isSolanaNetwork(network)) {
    return `https://solscan.io/account/${address}`;
  }

  const baseUrl = EVM_EXPLORER_MAP[network.chainId || ''] || 'https://polygonscan.com';
  return `${baseUrl}/address/${address}`;
};

export const getExplorerTxUrl = (
  network: Network | null | undefined,
  txHash: string
): string => {
  if (!network || !txHash) return '#';

  if (isSolanaNetwork(network)) {
    return `https://solscan.io/tx/${txHash}`;
  }

  const baseUrl = EVM_EXPLORER_MAP[network.chainId || ''] || 'https://polygonscan.com';
  return `${baseUrl}/tx/${txHash}`;
};
